import {
  createSupabaseClient,
  setSupabaseAuth as setAuth,
} from "@semo/supabase-client";

// Create singleton instance with Vite env config
export const supabase = createSupabaseClient({
  url: import.meta.env.VITE_SUPABASE_URL,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  config: {
    global: {
      headers: {
        "x-client-type": "vendor",
      },
    },
  },
});

// Re-export JWT setter for backward compatibility
export const setSupabaseAuth = (accessToken: string) => {
  setAuth(supabase, accessToken);
};
